module.exports = __webpack_public_path__ + "static/selects-placeholdersize-do-01eb35eaae2a070bfc16192925ffa36d.png";